import { fromJS } from 'immutable';

export const updateExistingModifier = (modifiers, modifierToUpdate, values, comboGroup) => {
  let updated =
    values.length === 0
      ? modifiers.remove(modifierToUpdate)
      : modifiers.setIn([modifierToUpdate, 'values'], fromJS(values));

  if (comboGroup) {
    updated = updated.filter(m => m.getIn(['modifier', 'parent_combo_group_id']) !== comboGroup).toList();
  }

  return updated;
};

/**
 * Inserts a selected modifier into the modifiers list. If the modifier is a child of a parent combo group,
 * inserts it after this parent.
 *
 */
export const insertNewModifier = (modifiers, group, comboGroup, selectedModifier, values) => {
  const parentComboGroupId = selectedModifier.get('parent_combo_group_id');
  const newModifier = fromJS({ group, combo_group: comboGroup, modifier: selectedModifier, values });

  if (parentComboGroupId) {
    const parentIndex = modifiers.findIndex(m => m.get('combo_group') === parentComboGroupId);
    if (parentIndex !== -1) {
      return modifiers.insert(parentIndex + 1, newModifier);
    }
  }
  return modifiers.push(newModifier);
};

export const getSelectedModifierValues = (modifiers, modifier) => {
  const groupId = modifier.get('groupId') ?? null;
  const comboGroupId = modifier.get('combo_group_id') ?? null;

  let modifierState;
  if (groupId !== null) {
    modifierState = modifiers.find(
      m => m.get('group') === groupId && m.getIn(['modifier', 'id']) === modifier.get('id')
    );
  } else if (comboGroupId !== null) {
    modifierState = modifiers.find(
      m => m.get('combo_group') === comboGroupId && m.getIn(['modifier', 'id']) === modifier.get('id')
    );
  }
  return modifierState ? modifierState.get('values').toJS() : [];
};

export const transformModifierValues = value => (typeof value === 'string' ? [{ value }] : value);
